"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.notTooGuessable = exports.isValidPassword = exports.isAtLeastEightChars = exports.hasUpperCaseLetter = exports.hasSpecialCharacter = exports.hasLowerCaseLetter = exports.hasDigit = void 0;
var _passwordValidator = _interopRequireDefault(require("password-validator"));
var _zxcvbn = _interopRequireDefault(require("zxcvbn"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var schema = new _passwordValidator.default();
var allowedSpecialChars = /[!@#$%^&*(){}[\]<>?/\\|,.~`"':;_-]/;
schema.is().min(8).has().uppercase().has().lowercase().has().digits().has().symbols().has(allowedSpecialChars).has().not().spaces();
var isValidPassword = input => {
  return schema.validate(input);
};

// Only validates length min 8 characters
exports.isValidPassword = isValidPassword;
var lengthSchema = new _passwordValidator.default();
lengthSchema.is().min(8).has().not().spaces();
var isAtLeastEightChars = input => {
  return lengthSchema.validate(input);
};

// Only validates for containing at least one lowercase letter
exports.isAtLeastEightChars = isAtLeastEightChars;
var lowerCaseLetterSchema = new _passwordValidator.default();
lowerCaseLetterSchema.has().lowercase().has().not().spaces();
var hasLowerCaseLetter = input => {
  return lowerCaseLetterSchema.validate(input);
};

// Only validates for containing at least one uppercase letter
exports.hasLowerCaseLetter = hasLowerCaseLetter;
var upperCaseLetterSchema = new _passwordValidator.default();
upperCaseLetterSchema.has().uppercase().has().not().spaces();
var hasUpperCaseLetter = input => {
  return upperCaseLetterSchema.validate(input);
};

// Only validates for containing special character
exports.hasUpperCaseLetter = hasUpperCaseLetter;
var specialCharSchema = new _passwordValidator.default();
specialCharSchema.has().symbols().has(allowedSpecialChars).has().not().spaces();
var hasSpecialCharacter = input => {
  return specialCharSchema.validate(input);
};

// Only validates for containing digits
exports.hasSpecialCharacter = hasSpecialCharacter;
var digitsSchema = new _passwordValidator.default();
digitsSchema.has().digits().has().not().spaces();
var hasDigit = input => {
  return digitsSchema.validate(input);
};

// Only validates that password is not too guessable
exports.hasDigit = hasDigit;
var notTooGuessable = input => {
  return (0, _zxcvbn.default)(input).score >= 2;
};
exports.notTooGuessable = notTooGuessable;